const BASE_URL = require('../config');
import React, { useState, useEffect } from 'react';
const API_URL = BASE_URL + '/api/potential_products';
const C_PARTY_API_URL = BASE_URL + '/api/counterparties';
const PRODUCTS_API_URL = BASE_URL + '/api/products';
const PALETTE_PASTEL = ['bg-pink-200 text-pink-800','bg-purple-200 text-purple-800','bg-blue-200 text-blue-800','bg-cyan-200 text-cyan-800','bg-teal-200 text-teal-800','bg-green-200 text-green-800','bg-yellow-200 text-yellow-800','bg-orange-200 text-orange-800'];

function getTodayStr() {
  const d = new Date();
  return d.toISOString().split('T')[0];
}

export default function PotentialPageV2() {
  const [items, setItems] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingCell, setEditingCell] = useState(null);
  const [cellEditValue, setCellEditValue] = useState('');
  const [name, setName] = useState('');
  const [quantity, setQuantity] = useState(1);
  const [purchasePrice, setPurchasePrice] = useState('');
  const [marketLow, setMarketLow] = useState('');
  const [sellingPrice, setSellingPrice] = useState('');
  const [orderDate, setOrderDate] = useState(getTodayStr());
  const [cancelDate, setCancelDate] = useState(getTodayStr());
  const [counterparty, setCounterparty] = useState('');
  const [comment, setComment] = useState('');
  const [isPaid, setIsPaid] = useState('нет');
  const [selectedIds, setSelectedIds] = useState([]);
  const [counterparties, setCounterparties] = useState([]);
  const [showCounterpartyModal, setShowCounterpartyModal] = useState(false);
  const [newCounterparty, setNewCounterparty] = useState('');
  const [editingCounterparty, setEditingCounterparty] = useState(null);
  const [editCounterpartyName, setEditCounterpartyName] = useState('');
  const [editModal, setEditModal] = useState(null); // {item, field, label, type}
  const [editModalValue, setEditModalValue] = useState('');

  const fetchData = async () => {
    const res = await fetch(API_URL, { headers: { 'tg-id': localStorage.getItem('tg_user') || '' } });
    const data = await res.json();
    setItems(data);
  };

  useEffect(() => { fetchData(); fetchCounterparties(); }, []);

  const fetchCounterparties = async () => {
    const res = await fetch(C_PARTY_API_URL, { headers: { 'tg-id': localStorage.getItem('tg_user') || '' } });
    const data = await res.json();
    setCounterparties(data);
  };

  const addCounterparty = async () => {
    if (!newCounterparty.trim()) return;
    await fetch(C_PARTY_API_URL, { method: 'POST', headers: { 'Content-Type': 'application/json', 'tg-id': localStorage.getItem('tg_user') || '' }, body: JSON.stringify({ name: newCounterparty, color: PALETTE_PASTEL[0] }) });
    setNewCounterparty(''); fetchCounterparties();
  };

  const deleteCounterparty = async (id) => {
    if (!window.confirm('Удалить контрагента?')) return;
    await fetch(`${C_PARTY_API_URL}/${id}`, { method: 'DELETE', headers: { 'tg-id': localStorage.getItem('tg_user') || '' } });
    fetchCounterparties();
  };

  const updateCounterparty = async (id) => {
    await fetch(`${C_PARTY_API_URL}/${id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json', 'tg-id': localStorage.getItem('tg_user') || '' }, body: JSON.stringify({ name: editCounterpartyName, color: PALETTE_PASTEL[0] }) });
    setEditingCounterparty(null); fetchCounterparties();
  };

  useEffect(() => {
    const handleKey = (e) => { if (e.key === 'Escape') { if (editingCell) { setEditingCell(null); setCellEditValue(''); } if (showForm) setShowForm(false); } };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [editingCell, showForm]);

  const handleAdd = async () => {
    if (!name) { alert('Введите наименование'); return; }
    await fetch(API_URL, { method: 'POST', headers: { 'Content-Type': 'application/json', 'tg-id': localStorage.getItem('tg_user') || '' }, body: JSON.stringify({ name, quantity: parseInt(quantity)||1, purchase_price: parseFloat(purchasePrice)||0, market_low: parseFloat(marketLow)||0, selling_price: parseFloat(sellingPrice)||0, order_date: orderDate, cancel_date: cancelDate, is_paid: isPaid, counterparty: counterparty, comment }) });
    setName(''); setQuantity(1); setPurchasePrice(''); setMarketLow(''); setSellingPrice(''); setOrderDate(getTodayStr()); setCancelDate(getTodayStr()); setIsPaid('нет'); setCounterparty(''); setComment('');
    setShowForm(false); fetchData();
  };

  const startEdit = (item, field) => { setEditingCell({ id: item.id, field }); setCellEditValue(item[field] ?? ''); };

  const openEditModal = (item, field, label, type = 'text') => {
    setEditModal({ item, field, label, type });
    setEditModalValue(item[field] ?? '');
  };

  const saveEditModal = async () => {
    const item = editModal.item;
    const updated = { ...item, [editModal.field]: editModalValue };
    await fetch(`${API_URL}/${item.id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json', 'tg-id': localStorage.getItem('tg_user') || '' }, body: JSON.stringify(updated) });
    setEditModal(null); setEditModalValue(''); fetchData();
  };
  const cancelEdit = () => { setEditingCell(null); setCellEditValue(''); };

  const saveEdit = async () => {
    const item = items.find(i => i.id === editingCell.id);
    if (!item) return;
    const updated = { ...item, [editingCell.field]: cellEditValue };
    await fetch(`${API_URL}/${item.id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json', 'tg-id': localStorage.getItem('tg_user') || '' }, body: JSON.stringify(updated) });
    setEditingCell(null); setCellEditValue(''); fetchData();
  };

  const deleteSelected = async () => {
    if (!window.confirm(`Удалить ${selectedIds.length} записей?`)) return;
    await Promise.all(selectedIds.map(id => fetch(`${API_URL}/${id}`, { method: 'DELETE', headers: { 'tg-id': localStorage.getItem('tg_user') || '' } })));
    setSelectedIds([]); fetchData();
  };

  const toggleSelect = (id) => setSelectedIds(prev => prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]);

  const cellClass = 'px-3 py-2 border-b border-r border-slate-200 text-left cursor-pointer hover:bg-indigo-50 text-xs';

  const renderCell = (item, field, display, label, type = 'text') => {
    if (editingCell?.id === item.id && editingCell?.field === field) {
      return (
        <td key={field} className="px-3 py-2 border-b border-r border-slate-200 bg-indigo-50">
          <div className="flex items-center space-x-1">
            <input autoFocus value={cellEditValue} onChange={e => setCellEditValue(e.target.value)} onKeyDown={e => { if(e.key==="Enter") saveEdit(); if(e.key==="Escape") cancelEdit(); }} className="w-full border border-indigo-400 rounded px-1 py-0.5 text-xs outline-none" />
            <button onClick={saveEdit} className="text-emerald-500 font-bold">✓</button>
            <button onClick={cancelEdit} className="text-red-400 font-bold">✕</button>
          </div>
        </td>
      );
    }
    return <td key={field} className={cellClass} onClick={() => openEditModal(item, field, label || field, type)}>{display ?? item[field] ?? "-"}</td>;
  };

  return (
    <div className="max-w-[1600px] mx-auto pb-48 px-4">
      <div className="flex justify-between items-center mb-3 mt-2">
        <h1 className="text-sm font-bold text-slate-700">Потенциальные товары</h1>
        <div className="flex space-x-2">
          {selectedIds.length === 1 && (<button onClick={() => {
            const p = items.find(x => x.id === selectedIds[0]);
            if (p) {
              setName(p.name || '');
              setQuantity(p.quantity || 1);
              setPurchasePrice(p.purchase_price || '');
              setMarketLow(p.market_low || '');
              setSellingPrice(p.selling_price || '');
              setOrderDate(getTodayStr());
              setCancelDate(getTodayStr());
              setIsPaid('нет');
              setCounterparty(p.counterparty || '');
              setComment(p.comment || '');
              setShowForm(true);
              setSelectedIds([]);
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }
          }} className="bg-amber-500 hover:bg-amber-600 text-white w-8 h-8 rounded font-semibold shadow-sm transition-colors flex items-center justify-center" title="Копировать">⧉</button>)}
          {selectedIds.length > 0 && <button onClick={deleteSelected} className="bg-red-500 hover:bg-red-600 text-white px-3 py-1.5 rounded text-xs font-semibold">🗑️ Удалить ({selectedIds.length})</button>}
          <button onClick={() => setShowForm(!showForm)} className="bg-indigo-600 hover:bg-indigo-700 text-white px-3 py-1.5 rounded text-xs font-semibold">{showForm ? "Скрыть" : "+ Добавить"}</button>
        </div>
      </div>

      {showForm && (
        <div className="bg-white p-4 rounded-xl shadow-sm border border-slate-200 mb-4">
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-2">
            <div className="col-span-2"><label className="text-[10px] text-slate-500 font-bold uppercase block mb-1">Наименование *</label><input value={name} onChange={e => setName(e.target.value)} className="w-full border border-slate-300 p-1.5 rounded text-xs" /></div>
            <div><label className="text-[10px] text-slate-500 font-bold uppercase block mb-1">Кол-во</label><input type="number" min="1" value={quantity} onChange={e => setQuantity(e.target.value)} className="w-full border border-slate-300 p-1.5 rounded text-xs" /></div>
            <div><label className="text-[10px] text-slate-500 font-bold uppercase block mb-1">Цена закупа</label><input type="number" value={purchasePrice} onChange={e => setPurchasePrice(e.target.value)} className="w-full border border-slate-300 p-1.5 rounded text-xs" /></div>
            <div><label className="text-[10px] text-slate-500 font-bold uppercase block mb-1">Низ по рынку</label><input type="number" value={marketLow} onChange={e => setMarketLow(e.target.value)} className="w-full border border-slate-300 p-1.5 rounded text-xs" /></div>
            <div><label className="text-[10px] text-slate-500 font-bold uppercase block mb-1">Цена продажи</label><input type="number" value={sellingPrice} onChange={e => setSellingPrice(e.target.value)} className="w-full border border-slate-300 p-1.5 rounded text-xs" /></div>
            <div><label className="text-[10px] text-slate-500 font-bold uppercase block mb-1">Дата заказа</label><input type="date" value={orderDate} onChange={e => setOrderDate(e.target.value)} className="w-full border border-slate-300 p-1.5 rounded text-xs" /></div>
            <div><label className="text-[10px] text-slate-500 font-bold uppercase block mb-1">Дата аннул.</label><input type="date" value={cancelDate} onChange={e => setCancelDate(e.target.value)} className="w-full border border-slate-300 p-1.5 rounded text-xs" /></div>
            <div><label className="text-[10px] text-slate-500 font-bold uppercase block mb-1">Оплачен</label><select value={isPaid} onChange={e => setIsPaid(e.target.value)} className="w-full border border-slate-300 p-1.5 rounded text-xs"><option value="нет">Нет</option><option value="да">Да</option></select></div>
            <div><label className="text-[10px] text-slate-500 font-bold uppercase block mb-1">Контрагент</label><select value={counterparty} onChange={e => setCounterparty(e.target.value)} className="w-full border border-slate-300 p-1.5 rounded text-xs"><option value="">— Выберите —</option>{counterparties.map(c => <option key={c.id} value={c.name}>{c.name}</option>)}</select></div>
            <div className="col-span-2"><label className="text-[10px] text-slate-500 font-bold uppercase block mb-1">Комментарий</label><input value={comment} onChange={e => setComment(e.target.value)} className="w-full border border-slate-300 p-1.5 rounded text-xs" /></div>
            <div className="flex items-end"><button onClick={handleAdd} className="w-full bg-emerald-500 hover:bg-emerald-600 text-white p-1.5 rounded text-xs font-semibold">Добавить</button></div>
          </div>
        </div>
      )}

      <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-x-auto">
        <table className="min-w-full text-xs border-collapse">
          <thead>
            <tr className="bg-slate-200 text-slate-700">
              <th className="px-3 py-2 text-left font-bold uppercase text-[11px] w-8"><input type="checkbox" onChange={e => { if(e.target.checked) setSelectedIds(items.map(i => i.id)); else setSelectedIds([]); }} checked={selectedIds.length === items.length && items.length > 0} className="w-3.5 h-3.5" /></th>
              <th className="px-3 py-2 text-left font-bold uppercase text-[11px]">ID</th>
              <th className="px-3 py-2 text-left font-bold uppercase text-[11px]">Наименование</th>
              <th className="px-3 py-2 text-left font-bold uppercase text-[11px]">Кол-во</th>
              <th className="px-3 py-2 text-left font-bold uppercase text-[11px]">Цена закупа</th>
              <th className="px-3 py-2 text-left font-bold uppercase text-[11px]">Низ по рынку</th>
              <th className="px-3 py-2 text-left font-bold uppercase text-[11px]">Цена продажи</th>
              <th className="px-3 py-2 text-left font-bold uppercase text-[11px]">Маржа</th>
              <th className="px-3 py-2 text-left font-bold uppercase text-[11px]">Дата заказа</th>
              <th className="px-3 py-2 text-left font-bold uppercase text-[11px]">Дата аннул.</th>
              <th className="px-3 py-2 text-left font-bold uppercase text-[11px]">Оплачен</th>
              <th className="px-3 py-2 text-left font-bold uppercase text-[11px]"><div className="flex items-center space-x-1"><span>Контрагент</span><span onClick={() => setShowCounterpartyModal(true)} className="cursor-pointer opacity-50 hover:opacity-100 text-xs">⚙️</span></div></th>
              <th className="px-3 py-2 text-left font-bold uppercase text-[11px]">Комментарий</th>
              <th className="px-3 py-2 text-left font-bold uppercase text-[11px]">На склад</th>
            </tr>
          </thead>
          <tbody>
            {items.map(item => {
              const margin = (item.selling_price || 0) - (item.purchase_price || 0);
              return (
                <tr key={item.id} className={selectedIds.includes(item.id) ? "bg-indigo-50" : "hover:bg-slate-50"}>
                  <td className="px-3 py-2 border-b border-r border-slate-200"><input type="checkbox" checked={selectedIds.includes(item.id)} onChange={() => toggleSelect(item.id)} className="w-3.5 h-3.5" /></td>
                  <td className="px-3 py-2 border-b border-r border-slate-200 text-slate-400 font-mono">#{item.id}</td>
                  {renderCell(item, "name", null, "Наименование")}
                  {renderCell(item, "quantity", `${item.quantity} шт`, "Количество", "number")}
                  {renderCell(item, "purchase_price", item.purchase_price ? `${item.purchase_price} ₽` : "-", "Цена закупа", "number")}
                  {renderCell(item, "market_low", item.market_low ? `${item.market_low} ₽` : "-", "Низ по рынку", "number")}
                  {renderCell(item, "selling_price", item.selling_price ? `${item.selling_price} ₽` : "-", "Цена продажи", "number")}
                  <td className={`px-3 py-2 border-b border-r border-slate-200 font-semibold text-xs ${margin > 0 ? "text-emerald-600" : margin < 0 ? "text-red-500" : "text-slate-400"}`}>{item.selling_price ? `${margin} ₽` : "-"}</td>
                  {renderCell(item, "order_date", item.order_date ? new Date(item.order_date).toLocaleDateString("ru-RU") : "-", "Дата заказа", "date")}
                  {renderCell(item, "cancel_date", item.cancel_date ? new Date(item.cancel_date).toLocaleDateString("ru-RU") : "-", "Дата аннул.", "date")}
                  <td className="px-3 py-2 border-b border-r border-slate-200">
                    {editingCell?.id === item.id && editingCell?.field === "is_paid" ? (
                      <select autoFocus value={cellEditValue} onChange={e => setCellEditValue(e.target.value)} onBlur={saveEdit} className="border border-indigo-400 rounded px-1 py-0.5 text-xs outline-none">
                        <option value="нет">Нет</option>
                        <option value="да">Да</option>
                      </select>
                    ) : (
                      <span onClick={() => openEditModal(item, "is_paid", "Оплачен", "select_paid")} className={`cursor-pointer px-2 py-0.5 rounded font-bold text-[11px] ${item.is_paid === "да" ? "bg-emerald-100 text-emerald-700" : "bg-red-100 text-red-600"}`}>{item.is_paid === "да" ? "Да" : "Нет"}</span>
                    )}
                  </td>
                  {renderCell(item, "counterparty", item.counterparty || "-", "Контрагент", "counterparty")}
                  {renderCell(item, "comment", null, "Комментарий")}
                  <td className="px-3 py-2 border-b border-r border-slate-200 text-center">
                    <button onClick={async () => {
                      const today = new Date().toISOString().slice(0, 10);
                      await fetch(PRODUCTS_API_URL, { method: 'POST', headers: { 'Content-Type': 'application/json', 'tg-id': localStorage.getItem('tg_user') || '' }, body: JSON.stringify({ name: item.name, category: '', purchase_price: item.purchase_price || 0, selling_price: item.selling_price || 0, counterparty: item.counterparty || '', comment: item.comment || '', quantity: item.quantity || 1, custom_status: 'В наличии', purchase_date: today }) });
                      await fetch(`${API_URL}/${item.id}`, { method: 'DELETE', headers: { 'tg-id': localStorage.getItem('tg_user') || '' } });
                      fetchData();
                    }} className="bg-emerald-500 hover:bg-emerald-600 text-white px-2 py-1 rounded text-[11px] font-bold whitespace-nowrap">На склад</button>
                  </td>
                </tr>
              );
            })}
            {items.length === 0 && <tr><td colSpan={14} className="px-6 py-8 text-center text-slate-400">Нет записей. Нажмите "+ Добавить".</td></tr>}
          </tbody>
        </table>
      </div>
      {showCounterpartyModal && (
        <div className="fixed inset-0 bg-slate-900/60 z-[200] flex items-center justify-center p-4" onClick={() => setShowCounterpartyModal(false)}>
          <div className="bg-white rounded-2xl w-full max-w-sm shadow-2xl p-5 max-h-[80vh] flex flex-col" onClick={e => e.stopPropagation()}>
            <h3 className="text-sm font-bold text-slate-700 mb-3">Справочник контрагентов</h3>
            <div className="flex space-x-2 mb-3">
              <input value={newCounterparty} onChange={e => setNewCounterparty(e.target.value)} placeholder="Новый контрагент..." className="flex-1 border border-slate-300 rounded px-2 py-1.5 text-sm outline-none" onKeyDown={e => e.key === 'Enter' && addCounterparty()} />
              <button onClick={addCounterparty} className="bg-indigo-600 text-white px-3 py-1.5 rounded text-sm font-semibold">+</button>
            </div>
            <div className="overflow-y-auto flex-1 space-y-1">
              {counterparties.map(c => (
                <div key={c.id} className="flex items-center justify-between p-2 bg-slate-50 rounded">
                  {editingCounterparty === c.id ? (
                    <div className="flex flex-1 items-center space-x-1">
                      <input autoFocus value={editCounterpartyName} onChange={e => setEditCounterpartyName(e.target.value)} className="flex-1 border border-indigo-400 rounded px-2 py-1 text-sm outline-none" onKeyDown={e => { if(e.key === 'Enter') updateCounterparty(c.id); if(e.key === 'Escape') setEditingCounterparty(null); }} />
                      <button onClick={() => updateCounterparty(c.id)} className="text-emerald-500 font-bold">✓</button>
                      <button onClick={() => setEditingCounterparty(null)} className="text-red-400 font-bold">✕</button>
                    </div>
                  ) : (
                    <>
                      <span className="text-sm text-slate-700">{c.name}</span>
                      <div className="flex space-x-2">
                        <button onClick={() => { setEditingCounterparty(c.id); setEditCounterpartyName(c.name); }} className="text-indigo-500 text-xs hover:text-indigo-700">✏️</button>
                        <button onClick={() => deleteCounterparty(c.id)} className="text-red-400 text-xs hover:text-red-600">🗑️</button>
                      </div>
                    </>
                  )}
                </div>
              ))}
            </div>
            <button onClick={() => setShowCounterpartyModal(false)} className="mt-3 w-full bg-slate-100 text-slate-700 py-2 rounded font-semibold text-sm">Закрыть</button>
          </div>
        </div>
      )}

      {editModal && (
        <div className="fixed inset-0 bg-slate-900/60 z-[200] flex items-center justify-center p-4" onClick={() => setEditModal(null)}>
          <div className="bg-white rounded-2xl w-full max-w-sm shadow-2xl p-5" onClick={e => e.stopPropagation()}>
            <h3 className="text-sm font-bold text-slate-700 mb-3">{editModal.label}</h3>
            {editModal.field === 'counterparty' ? (
              <div className="mb-4">
                <select value={editModalValue} onChange={e => setEditModalValue(e.target.value)} className="w-full border border-indigo-400 rounded-lg px-3 py-2 text-sm outline-none mb-2">
                  <option value="">— Не выбран —</option>
                  {counterparties.map(c => <option key={c.id} value={c.name}>{c.name}</option>)}
                </select>
              </div>
            ) : editModal.type === 'select_paid' ? (
              <div className="flex space-x-2 mb-4">
                <button onClick={() => setEditModalValue('нет')} className={`flex-1 py-2 rounded-lg font-semibold text-sm ${editModalValue === 'нет' ? 'bg-red-500 text-white' : 'bg-slate-100 text-slate-700'}`}>Нет</button>
                <button onClick={() => setEditModalValue('да')} className={`flex-1 py-2 rounded-lg font-semibold text-sm ${editModalValue === 'да' ? 'bg-emerald-500 text-white' : 'bg-slate-100 text-slate-700'}`}>Да</button>
              </div>
            ) : (
              <input autoFocus type={editModal.type === 'number' ? 'number' : editModal.type === 'date' ? 'date' : 'text'} value={editModalValue} onChange={e => setEditModalValue(e.target.value)} className="w-full border border-indigo-400 rounded-lg px-3 py-2 text-sm outline-none focus:ring-1 focus:ring-indigo-500 mb-4" />
            )}
            <div className="flex space-x-2">
              <button onClick={() => setEditModal(null)} className="flex-1 bg-slate-100 text-slate-700 py-2 rounded-lg font-semibold text-sm">Отмена</button>
              <button onClick={saveEditModal} className="flex-1 bg-indigo-600 text-white py-2 rounded-lg font-semibold text-sm">Сохранить</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
// cache bust Fri Apr 24 10:38:20 UTC 2026
